import { Command as CommandPrimitive } from 'cmdk';
import React from 'react';

import { cn } from '@/services/utils';

const CommandList = React.forwardRef<
    React.ElementRef<typeof CommandPrimitive.List>,
    React.ComponentPropsWithoutRef<typeof CommandPrimitive.List>
>(({ className, ...props }, ref) => (
    <CommandPrimitive.List
        ref={ref}
        className={cn('tw-max-h-[300px] tw-overflow-y-auto tw-overflow-x-hidden', className)}
        {...props}
    />
));

CommandList.displayName = CommandPrimitive.List.displayName;

export { CommandList };
